import { render } from "./UsadosDetails.vue?vue&type=template&id=1b493a44"
import script from "./UsadosDetails.vue?vue&type=script&lang=js"
export * from "./UsadosDetails.vue?vue&type=script&lang=js"

import "./UsadosDetails.vue?vue&type=style&index=0&id=1b493a44&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__